<template lang="pug">
  div
    design-doc
</template>

<script>
  import DesignDoc from './getting-started/design-doc';
  export default {
    components: { DesignDoc },
  };
</script>
